import { Link, useLocation } from "react-router-dom";
import { ROUTES } from "../../router/mobile/routes";
import styles from "./MobileTabBar.module.scss";

type IconProps = { active: boolean };

const TabIconHome = ({ active }: IconProps) => {
  const stroke = active ? "#161646" : "#94A3B8";
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </svg>
  );
};

const TabIconUsers = ({ active }: IconProps) => {
  const stroke = active ? "#161646" : "#94A3B8";
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
};

const TabIconProfile = ({ active }: IconProps) => {
  const stroke = active ? "#161646" : "#94A3B8";
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
};

export function MobileTabBar() {
  const { pathname } = useLocation();
  const homeActive =
    pathname === ROUTES.DASHBOARD || pathname.startsWith("/setup/");
  // Users sub-pages (e.g. /users/activate) should keep the Users tab lit so
  // the technician doesn't lose their bearings while on the activate flow.
  const usersActive =
    pathname === ROUTES.PENDING_USERS || pathname.startsWith("/users/");
  const profileActive = pathname === ROUTES.PROFILE;

  type TabSpec = {
    to: string;
    label: string;
    active: boolean;
    Icon: (p: IconProps) => JSX.Element;
  };

  const tabs: TabSpec[] = [
    {
      to: ROUTES.DASHBOARD,
      label: "Home",
      active: homeActive,
      Icon: TabIconHome,
    },
    {
      to: ROUTES.PENDING_USERS,
      label: "Users",
      active: usersActive,
      Icon: TabIconUsers,
    },
    {
      to: ROUTES.PROFILE,
      label: "Profile",
      active: profileActive,
      Icon: TabIconProfile,
    },
  ];

  return (
    <nav className={styles.tabBar} aria-label="Setup mode navigation">
      <div className={styles.row}>
        {tabs.map(({ to, label, active, Icon }) => (
          <Link
            key={to}
            to={to}
            className={`${styles.tab} ${active ? styles.tabActive : ""}`}
            aria-current={active ? "page" : undefined}
          >
            <span className={styles.iconWrap}>
              <Icon active={active} />
            </span>
            <span className={styles.label}>{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
